@if (widgetComponent.isLoading) {
  <div>
    <my-spinner></my-spinner>
  </div>
} @else {
  <div>
    <h3>{{addTitle}}</h3>
    <form (submit)="widgetComponent.addWidget()" novalidate name="addForm">
      <ng-container *ngTemplateOutlet="widgetParamsTemplate;context:{widget:widgetComponent.newWidget}"></ng-container>
      <div class="element-btn-row">
        <button type="submit" class="element-btn" [disabled]="widgetComponent.isUpdating">
          {{'Add widget' | translate}}
        </button>
      </div>
    </form>

    @if (widgetComponent.widgets.length) {
      <div style="margin-top: 36px">
        <h3>{{editTitle}}</h3>
        @for (widget of widgetComponent.widgets; track widget) {
          <details [open]="widget.id === widgetComponent.defaultExpandedWidgetId">
            <summary>{{widget.name || widget.url || widgetComponent.defaultName}}</summary>
            <form (submit)="widgetComponent.saveWidget(widget)" novalidate name="editForm">
              <ng-container *ngTemplateOutlet="widgetParamsTemplate;context:{widget:widget}"></ng-container>
              <div class="element-btn-row">
                <button type="submit" class="element-btn" [disabled]="widgetComponent.isUpdating">
                  {{'Save' | translate}}
                </button>
                <button type="button" class="element-btn element-btn-danger-link" [disabled]="widgetComponent.isUpdating"
                  (click)="widgetComponent.removeWidget(widget)">
                  {{'Remove widget' | translate}}
                </button>
              </div>
            </form>
          </details>
        }
      </div>
    }
  </div>
}
